import React from 'react';
import LOOKUP from 'constants/lookup';
import GenericTable from 'screens/components/advanced/GenericTable';
import Pagination from 'screens/components/basic/Pagination';
import CardSimple from 'screens/components/basic/CardSimple';
import { mapCampaign } from 'utils/mappers';

const CampaignHistory = ({ campaign, pagination, changePage }) => {
    const compName = "campaign";
    return (
        <div className="product-content list-table">
            <CardSimple>
                <GenericTable
                    className="table_center"
                    multiSelectable={false}
                    enableSelectAll={false}
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                    displayRowCheckbox={false}
                    selectable={true}
                    stripedRows={true}
                    columns={LOOKUP.campaign.productCampaignColumns}
                    rows={mapCampaign(campaign.list)}
                />
                <Pagination
                    length={campaign.total}
                    itemsPerPage={pagination.itemsPerPage}
                    activePage={pagination.activePage}
                    onPageChange={(e) => changePage(e, compName)}
                />
            </CardSimple>
        </div>
    )
}

export default CampaignHistory;